/* ============================================================
   YOLÈTE — Magazine : liste d'articles + filtres
   ============================================================ */

const articleGrid = document.getElementById('articleGrid');

function articleCard(a, feature = false) {
  const chip = a.type === 'presse'
    ? `Presse${a.source ? ' · ' + a.source : ''}`
    : 'Le Journal';
  return `
    <a class="article-card${feature ? ' feature' : ''}" href="${articleHref(a)}">
      <div class="article-media">
        <span class="article-kind">${chip}</span>
        <img src="${a.cover}" alt="${a.title}" loading="lazy" />
      </div>
      <div class="article-body">
        <div class="article-meta">${articleMeta(a)}</div>
        <h3>${a.title}</h3>
        <p>${a.excerpt}</p>
        <span class="article-link">Lire ${a.type === 'presse' ? 'le sujet' : "l'article"}</span>
      </div>
    </a>`;
}

function renderList(filter = 'all') {
  const list = filter === 'all' ? ARTICLES : ARTICLES.filter(a => a.type === filter);
  if (!list.length) { articleGrid.innerHTML = `<p class="empty-grid">Aucun article pour le moment.</p>`; return; }
  /* le 1er article featured (si présent dans la sélection) passe en grand */
  const feat = list.find(a => a.featured);
  const ordered = feat ? [feat, ...list.filter(a => a !== feat)] : list;
  articleGrid.innerHTML = ordered.map((a, i) => articleCard(a, feat && i === 0)).join('');
  observeReveals();
}

/* ---------- Filtres ---------- */
document.getElementById('magFilters').addEventListener('click', e => {
  const btn = e.target.closest('.filter');
  if (!btn) return;
  document.querySelectorAll('#magFilters .filter').forEach(f => f.classList.remove('active'));
  btn.classList.add('active');
  renderList(btn.dataset.filter);
});

/* ---------- Init (filtre depuis l'URL : ?type=presse) ---------- */
const initType = new URLSearchParams(location.search).get('type');
if (initType && ARTICLE_TYPE[initType]) {
  document.querySelectorAll('#magFilters .filter').forEach(f => f.classList.toggle('active', f.dataset.filter === initType));
  renderList(initType);
} else {
  renderList();
}
